export interface CreditToBalanceRequest {
    trading_account: string;
    amount: number;
    credit_reduction_only: boolean;
    comment_credit: string;
    comment_balance: string;
}

export interface CreditToBalanceResponse {
    trading_account: string;
    error_message?: string;
    credit_ticket?: string;
    balance_ticket?: string;
}
